import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "login flex w-full flex-col place-content-center h-lvh"
};
const _hoisted_2 = {
  class: "title text-center text-3xl font-bold mt-8"
};
const _hoisted_3 = {
  class: "w-full p-8"
};
import LoginDialog from "@/components/LoginDialog.vue";
import { getSystemInfo } from "@/store/cache";
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
export default {
  __name: 'Login',
  setup(__props) {
    const router = useRouter();
    const title = ref("登录");
    const loginSuccess = () => {
      router.back();
    };
    onMounted(() => {
      getSystemInfo().then(res => {
        title.value = res.data.title;
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(title.value), 1), _createElementVNode("div", _hoisted_3, [_createVNode(LoginDialog, {
        onSuccess: loginSuccess
      })])]);
    };
  }
};